type GraphAccountsValidatorProps = {
  accountRefs: (string | null)[];
  fallback: React.ReactNode;
  children: React.ReactNode;
};

export const GraphAccountsValidator = ({
  accountRefs,
  fallback,
  children,
}: GraphAccountsValidatorProps) => {
  return accountRefs.length > 1 ? fallback : children;
};
